import {Camera, CameraResultType, CameraSource} from '@capacitor/camera';
import {Capacitor} from '@capacitor/core';
import React, {useRef, useState} from "react";
import services from "../services";
import PButton from "./PButton.tsx";

const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const randomRef = () => 'file-' + [...Array(12)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join("");

const FileUploader = ({buttonText = 'Choose file...', className, buttonClassName, startContent, onUploaded, onError, category}: {
    buttonText: string,
    className?: string,
    buttonClassName?: string,
    startContent?: React.ReactNode,
    onUploaded: (data: any) => any,
    onError?: (error: any) => any,
    category: 'posts' | 'avatars' | 'sponsors' | 'logos'
}) => {
    const [status, setStatus] = useState<
        "initial" | "uploading" | "success" | "fail"
    >("initial");

    const [id] = useState(randomRef);

    const fileInput = useRef<HTMLInputElement>(null);

    const showAndroidFilePrompt = async () => {
        const image = await Camera.getPhoto({
            quality:    90,
            resultType: CameraResultType.DataUrl,
            source:     CameraSource.Prompt,
        });

        const response = await fetch(image.dataUrl || '');
        const blob = await response.blob();

        const file1 = new File(
            [blob],
            "fileName.jpg",
            {
                type: "image/jpeg",
            }
        );

        uploadFile(file1);
    };

    const startIosWebFilePrompt = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file1 = e.target.files[0];

            uploadFile(file1);
        }
    };

    const uploadFile = async (file1) => {
        setStatus("initial");
        setStatus("uploading");

        const formData = new FormData();
        formData.append("file", file1);
        formData.append("category", category);

        try {
            const data = await services.core.sponsorsUpload(formData);
            if (!data || data.error || !data.image_url) {
                const err = new Error(data?.error || data?.message || 'Upload failed');
                onError && onError(err);
                console.error('Upload failed:', data);
                setStatus("fail");
                return;
            }
            setStatus("success");
            onUploaded(data);
        } catch (error) {
            onError && onError(error);
            console.error(error);
            setStatus("fail");
        }
    }

    return (
        <>
            <div className={className}>
                <PButton className={buttonClassName ?? "w-full"}
                         startContent={startContent}
                         isLoading={status === "uploading"}
                         onPress={() => (Capacitor.getPlatform() === 'android' ? showAndroidFilePrompt() : fileInput.current?.click())}
                >
                    {status === "uploading" ? "Please wait..." : buttonText}
                </PButton>
                <input ref={fileInput} id={id} type="file" onChange={startIosWebFilePrompt} className="sr-only" />
            </div>
        </>
    );
};

const Result = ({status}: { status: string }) => {
    if (status === "success") {
        return <p>✅</p>;
    } else if (status === "fail") {
        return <p>❌</p>;
    } else if (status === "uploading") {
        return <p>⏳</p>;
    } else {
        return null;
    }
};

export default FileUploader;
